export const utils_isLocalLink = (url) => {
    if (typeof url !== "string" || !url.trim()) {
        throw new Error("Entrada inválida: deve ser uma string não vazia");
    }

    const u = url.trim();

    // Casos claramente externos (http, https, ftp, mailto, etc)
    if (/^(https?:|ftp:|mailto:|file:|\/\/)/i.test(u)) {
        return false;
    }

    // Começa com barra, ponto ou é um nome simples de arquivo → local
    if (/^(\.|\/|#)/.test(u)) {
        return true;
    }

    // Tem domínio explícito tipo "example.com" ou "www.site"
    if (/^[\w.-]+\.[a-z]{2,}(\/|$)/i.test(u)) {
        return false;
    }

    // Caso contrário, considere local
    return true;
}